module.exports = __webpack_public_path__ + "img/Cti12PapRbrSu0004A.de71ac77.jpg";